<template>
    <article class="activity" v-show="activity.isVisible">
        <h4><span>{{ activity.code }}.</span> {{ activity.title }}</h4>
        <table v-if="hasResults">
            <tbody>
                <tr v-for="(result, indexResult) in mainResults" 
                    :key="indexResult" 
                    class="result" 
                    v-show="result.isVisible">
                    <!-- <img :src="result.thumb" /> -->
                    <td>{{ indexResult + 1 }}.</td>
                    <td class="description" >
                        <a target="_blank" v-if="!result.url.includes('http')" :href="`http://test.igp.gob.pe/paginaigp/ppr2020/docs${result.url}`" >
                            <p> {{ result.title }} <span class="result-badge">{{ result.type }}</span></p>
                        </a>
                        <a target="_blank" v-else :href="result.url" >
                            <p> {{ result.title }} <span class="result-badge">{{ result.type }}</span></p>
                        </a>
                    </td>
                    <td class="text-muted text-right">{{ result.date }}</td>
                </tr>
            </tbody>
        </table>
        <section v-if="hasAppenedResults">
            <h5>
                <a class="link" @click="toggleButton" role="button">
                    Documentos Adicionales ({{ appenedResults.map( r => r.quantity ).reduce( (a, b) => a + b, 0 ) }})
                    <i class="fas fa-angle-down" v-if="!active"></i>  
                    <i class="fas fa-angle-up" v-else></i>  
                </a>
            </h5>
            <div :class="`reduce ${active ? 'active' : ''}`">
                <table class="reduce-body">
                    <tbody >
                        <tr v-for="(result, indexResult) in appenedResults" 
                            :key="indexResult" 
                            class="result" 
                            v-show="result.isVisible">
                            <!-- <img :src="result.thumb" /> -->
                            <td>{{ indexResult + 1 }}.</td>
                            <td class="description" >
                                <a target="_blank" v-if="!result.url.includes('http')" :href="`http://test.igp.gob.pe/paginaigp/ppr2020/docs${result.url}`" >
                                    <p> {{ result.title }} <span class="result-badge">{{ result.type }}</span></p>
                                </a>
                                <a target="_blank" v-else :href="result.url" >
                                    <p> {{ result.title }} <span class="result-badge">{{ result.type }}</span></p>
                                </a>
                            </td>
                            <td class="text-muted text-right">{{ result.date }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>
    </article>
</template>
<script>
export default {
    name: "Activity",
    props: {
        activity: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            active: false,
        }
    },
    computed: {
        hasResults() {
            return this.activity.results && this.activity.results.length;
        },
        hasAppenedResults() {
            return this.activity.results && this.activity.results.filter(result => result.bundle_id == 'APPENED').length;
        },
        mainResults() {
            return this.activity.results.filter(result => result.bundle_id == 'MAIN');
        },
        appenedResults() {
            return this.activity.results.filter(result => result.bundle_id == 'APPENED');
        },
    },
    methods: {
        toggleButton() {
            this.active = !this.active;
        }
    }
}
</script>
<style scoped>
    .activity {
        margin-left: 30px;
        margin-bottom: 20px;
    }
    .activity h4 {
        font-size: 1.2em;
        font-weight: 700;
        /* border-bottom: var(--bd-sections); */
        margin: 0;
        padding: 1.5rem 0;
    }
    .activity h5 {
        font-size: 1em;
        font-weight: 700;
        /* border-bottom: var(--bd-sections); */
        margin: 0;
        padding: 1rem 0;
    }
    .result {
        /* padding: .5rem 0; */
        border-bottom: var(--bd-sections);
        display: grid;
        grid-template-columns: 15px auto 90px;
        grid-gap: 10px;
        align-items: center;
    }
    .result:hover {
        background: var(--bg-sections);
    }
    .result:first-of-type  {
        border-top: var(--bd-sections);
    }
    .result img {
        width: 50px;
    }
    .result * {
        margin: 0;
        padding: 0;
    }    
    .result p {
        padding: .5em 0;
    }
    .result .result-badge {
        font-size: 80%;
        background-color: var(--bg-sections);
        height: auto;
        width: auto;
        padding: 3px 5px;
        border-radius: 5px;
        text-align: center;
        opacity: .8;
    }
    table {
        width: 100%;
    }
    .reduce {
        display: none;
    }
    .reduce.active {
        display: block;
    }
</style>